export const version = '2.7.4';
//# sourceMappingURL=version.js.map